
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import { all_routes } from "../../router/all_routes";
import BasicDetails from "./BasicDetails";
import Gurantors from "./Gurantors";
import Representatives from "./Representatives";
import Partners from "./Partners";
import Enclosures from "./Enclosures";
import Payment from "./Payment";
import { getAllAPMC } from "../../auth/services/apiCalling";
import { useSelector } from "react-redux";
import { getGcaApplicationExistencCheck, getGcaDraftApplication } from "../../auth/services/privateapicalling";
import { toast, ToastContainer } from "react-toastify";
// import ReCAPTCHA from "react-google-recaptcha";


export interface APMC {
  id: string;
  apmcName: string;
  District: string;
  district_id:string;
}

export interface Option {
  value: string;
  label: string;
}

export interface APMCResponse {
  success: boolean;
  data: any[];
  message: string;
}

const GCALicenseRegistrationForm = () => {
  const routes = all_routes;
  const [accepted, setAccepted] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  
  const [formData, setFormData] = useState<any>({});
  const token = useSelector((state:any)=>state.auth.token)
  const language = useSelector((state:any)=>state.auth.language)
  const navigate = useNavigate();

  const [loading , setLoading] = useState(false)
  const [isBasicDetailFilled , setIsBasicDetailFilled] = useState(false);
  const [isRepresentativeFilled , setIsRepresentativeFilled ] = useState(false);
  const [isFirmDetailFilled , setIsFirmDetailFilled] = useState(false);
  const [isEnclouserFilled , setIsEnclouserFilled] = useState(false);
  const [isGurantorFilled , setIsGurantorFilled] = useState(false);
  const [paymentStatus , setPaymentStatus] = useState<string | null>(null); 
  const [isAllowed,setIsAllowed] = useState(true);
  const [existData ,setExistData] = useState<any | null>(null);
  const [applicationId , setApplicationID] = useState<string | null>(null);
  const [entityType , setEntityType] = useState<string | null>(null);
  const [apmcOptions, setApmcOptions] = useState<Option[]>([]);
  
  const [districtOptions , setDistrictOptions] = useState<Option[]>([]);
  const [talukaOptions , setTalukaOptions] = useState<Option[]>([]);

  const [districtOptionsCurr , setDistrictOptionsCurr] = useState<Option[]>([]);
  const [talukaOptionsCurr , setTalukaOptionsCurr] = useState<Option[]>([]);
  const [districtOptionsPer , setDistrictOptionsPer] = useState<Option[]>([]);
  const [talukaOptionsPer , setTalukaOptionsPer] = useState<Option[]>([]);
    const [districtOptionsReg , setDistrictOptionsReg] = useState<Option[]>([]);
  const [talukaOptionsReg , setTalukaOptionsReg] = useState<Option[]>([]);

   const [selectData, setSelectData] = useState({
        district: '',
        taluka: '',
        addressToUpdate:''
      });

      const [selectCurr, setSelectCurr] = useState({
        district: '',
        taluka: '',
      });

         const [selectPer, setSelectPer] = useState({
        district: '',
        taluka: '',
      });

       const [selectReg, setSelectReg] = useState({
        district: '',
        taluka: '',
      });
      
  
      const handleDistTaluka = (e) => {
        const { name, value } = e.target;
     
        // setSelectData((prev) => {
        //   switch (name) {
        //     case 'district':
        //       return { district: value, taluka: ''};
        //     case 'taluka':
        //       return { ...prev, taluka: value};
        //     default:
        //       return prev;
        //   }
        // });
        
      };
 

const fetchAllDistrictTaluka = async (token: string, district?: string, taluka?: string, toUpdateDistOpt?: string): Promise<Option[]> => {
  try {
    let dist = district || (existData ? existData?.department?.district_id : '');
    let tal = taluka || '';

 

    const response = await getAllAPMC(token, dist, tal);

    if (dist && !tal) {
      // Load Talukas
      const talukas = response.data.map((t) => ({
        label: t.Taluka,
        value: t.Taluka,
      }));

      // Clear and set the appropriate taluka options
      if (toUpdateDistOpt === "pob") {
        setTalukaOptions(talukas);
        setApmcOptions([]); // Clear APMCs when district changes
      }
      if (toUpdateDistOpt === "curr") {
        setTalukaOptionsCurr(talukas);
      }
      if (toUpdateDistOpt === "per") {
        setTalukaOptionsPer(talukas);
      }
      if (toUpdateDistOpt === "reg") {
        setTalukaOptionsReg(talukas);
      }

    } else if (dist && tal) {
      // Load APMCs
      const apmcs = response.data.map((a) => ({
        label: a.apmcName,
        value: a.id,
      }));
      
      if (toUpdateDistOpt === "pob") {
        setApmcOptions(apmcs);
      }
    }

    return response.data;
  } catch (error) {
    
    return [];
  }
};

  const fetchDistrict =async()=>{
    try {
      const response = await getAllAPMC(token , '' , '');
   

      const districts = response.data.map((d) => ({
        label: d.District,
        value: d.district_id,
      }));

      setDistrictOptions(districts);

    } catch (error) {
      // alert('Internal Server Error')
      toast.error('Internal Server Error', {position: "top-right", autoClose: 3000,});
      
    }
  }
   useEffect(()=>{
      fetchDistrict();
  },[])

const fetchApplicationExistenceCheck = async() => {
  const getData = await getGcaApplicationExistencCheck(token);

  setIsAllowed(getData?.data?.isAllowed);
  setExistData(getData?.data);
  setApplicationID(getData?.data?.applicationId);
  setEntityType(getData?.data?.entityType);
}

//.log('exist data index', existData)

  const fetchApplicationIfExist = async () => {
    try {
      setLoading(true);
      //.log("fetchApplicationIfExist fetchApplicationIfExist");
  
      const data = await getGcaDraftApplication(token);
      //.log("draft data", data);
      setPaymentStatus( data?.status.paymentStatus)

      setIsBasicDetailFilled(data?.userDetail?.isBasicDetailFilled);
      setIsRepresentativeFilled(data?.userDetail?.isRepresentativeFilled);
      setIsFirmDetailFilled(data?.userDetail?.ifFirmDetailFilled);
      setIsEnclouserFilled(data?.userDetail?.isEnclouserFilled);
      setIsGurantorFilled(data?.userDetail?.isGurantorFilled);
  
      const stepConditions: { condition: boolean; step: number }[] = [
        { condition: !data?.userDetail?.isBasicDetailFilled, step: 0 },
        { condition: !data?.userDetail?.isRepresentativeFilled, step: 1 },
        { condition: !data?.userDetail?.ifFirmDetailFilled, step: 2 },
        { condition: !data?.userDetail?.isEnclouserFilled, step: 3 },
        { condition: !data?.userDetail?.isGurantorFilled, step: 4 },
        { condition: (data?.status.paymentStatus === "PENDING" || data?.status.paymentStatus === "FAILED"), step: 5 },
        { condition: data?.status.paymentStatus == null ||  data?.status.paymentStatus =="SUCCESS" , step: 0 }

      ];


    } catch (err) {
      //.log("No application found");
    } finally {
      setLoading(false);
    }
  };

  const EntityOptions = [
    { value: "Ind", label: "Individual" },
    { value: "Firm", label: "Firm" },
    { value: "Company", label: "Company" },
    { value: "CoSciety", label: "Cooperative Society" },
    { value: "Fpo", label: "Farmer Producer Organization (FPO)" },
    { value: "govEnt", label: "Government Entity" },
    { value: "Ngo", label: "Non-Governmental Organization (NGO)" },
    { value: "partnerFirm", label: "Partnership Firm" },
    { value: "Llp", label: "Limited Liability Partnership (LLP)" },
    { value: "Trust", label: "Trust" },
    { value: "Jv", label: "Joint Venture" },
  ];  
 
  const steps = ["Ind", "Company", "CoSciety", "Fpo", "govEnt", "Ngo", "partnerFirm", "Llp", "Trust", "Jv"].includes(entityType || "") ?

  [
    { name: language.basic_detail, key: "basic_details" },
    { name: language.representatives, key: "representatives" },
    { name: language.enclosures, key: "enclosures" },
    { name: language.guarantors, key: "guarantors" },
    { name: "Preview and Submit", key: "payment" }
  ]
  : 
  [ 
      { name: language.basic_detail, key: "basic_details" },
      { name: language.representatives, key: "representatives" },
      { name: language.firm_info, key: "partners" },
      { name: language.enclosures, key: "enclosures" },
      { name: language.guarantors, key: "guarantors" }, 
      { name: "Preview and Submit", key: "payment" }
  ]
;

  // Handle input change
  type StepKey = "basic_details" | "representatives" | "guarantors" | "partners" | "enclosures" | "payment";
 

 

   useEffect(() => {
    if (!existData) return;
  
    // Load POB data
    if (existData?.department?.district_id) {
      fetchAllDistrictTaluka(token, existData.department.district_id, "", "pob");
    }
  
    // Load current address data
    if (existData?.currAddress?.[0]?.district && existData?.currDistrictId) {
      fetchAllDistrictTaluka(token, existData.currDistrictId, "", "curr");
    }
  
    // Load permanent address data
    if (existData?.perAddress?.[0]?.district && existData?.perDistrictId) {
      fetchAllDistrictTaluka(token, existData.perDistrictId, "", "per");
    }
  
    // Load registered office address data
    if (existData?.regOffAddress?.[0]?.district && existData?.regDistrictId) {
      fetchAllDistrictTaluka(token, existData.regDistrictId, "", "reg");
    }
  }, [existData]);

   useEffect(() => {

    if (token) {
      // fetchAllDistrictTaluka(token);
      fetchApplicationIfExist();
    }
  }, []);


  useEffect(() => {
    if (token) {
      fetchApplicationIfExist();
    }
  }, []);

  useEffect(() => {
    //.log('payment status',)
    fetchApplicationExistenceCheck();

  }
  ,[])



  const handleNext = async(data?: any) => {
    //.log('stepp curr', currentStep)
    if (data) {
      setFormData((prev: any) => ({  ...data }));
    
      if(!formData)
      {
        //.log('no data found ')

      }
      else{
        await handleSubmit(data);
        fetchApplicationExistenceCheck();
      }
    }
    
    if (currentStep < steps.length - 1) {
      setCurrentStep((prev) => prev + 1);
    }
  };



  const handlePrev = () => {
    const prevStep = steps[currentStep - 1]
    setCurrentStep((prev) => (prev > 0 ? prev - 1 : prev));
    fetchApplicationExistenceCheck();
  };

  const handleSubmit = async(data:any)=>{
    //.log('form dataaa' , formData)
    //.log('dddddd' , data)
 
  }


  const renderFormFields = () => {


    
      const stepKey = steps[currentStep].key;
   
      if (!stepKey) {
       
        return null; 
      }
    

      
      switch (stepKey) {
          case "basic_details":
              return (
                <div>{existData && applicationId&& 
                <BasicDetails 
                  districtOptions={districtOptions}
                  talukaOptionsCurr={talukaOptionsCurr}
                  talukaOptionsReg={talukaOptionsReg}
                  talukaOptionsPer={talukaOptionsPer}
                  talukaOptions={talukaOptions}
                  apmcOptions={apmcOptions}
                  selectData={selectData}
                  setSelectData={setSelectData}
                  handleDistTaluka={handleDistTaluka} isAllowed={isAllowed}
                  existData={existData} applicationId={applicationId}
                  setApplicationID={setApplicationID}
                   onNext={handleNext} onPrev={handlePrev}
                   fetchApplicationIfExist={fetchApplicationIfExist}
                     fetchAllDistrictTaluka={fetchAllDistrictTaluka}
                   setApmcOptions={setApmcOptions}
                    setTalukaOptions={setTalukaOptions}
                  isBasicDetailFilled={isBasicDetailFilled} paymentStatus={paymentStatus} />}
                  </div>
              );
          case "guarantors":
            return (                                                                                                                                                            
                <div>                                                                                                                                                 
                  {existData && <Gurantors onNext={handleNext} 
                  fetchApplicationIfExist={fetchApplicationIfExist}
                  fetchApplicationExistenceCheck={fetchApplicationExistenceCheck}
                  existData={existData} 
                  applicationId={applicationId}
                  onPrev={handlePrev} isGurantorFilled={isGurantorFilled}  />}
                </div>
              );
          case "representatives":
              return (
                <>
              { existData && <Representatives  
                existData={existData} applicationId={applicationId}
                 fetchApplicationIfExist={fetchApplicationIfExist}
                 onNext={handleNext} onPrev={handlePrev} isRepresentativeFilled={isRepresentativeFilled} />}
                </>
              );
          case "partners":
              return (
                <>
               {existData && <Partners onNext={handleNext}
               existData={existData} applicationId={applicationId}
                onPrev={handlePrev} isFirmDetailFilled={isFirmDetailFilled} />}
                </>
              );
          case "enclosures":
              return (
               <>
             { existData && <Enclosures   existData={existData} applicationId={applicationId}
               fetchApplicationExistenceCheck={fetchApplicationExistenceCheck}
               onNext={handleNext} onPrev={handlePrev} isEnclouserFilled={isEnclouserFilled} />}

               </>   );
          case "payment":
              return (
                <>
                 {existData &&<Payment onPrev={handlePrev} 
                 existData={existData} applicationId={applicationId}
                 fetchApplicationExistenceCheck={fetchApplicationExistenceCheck}/>}
                </>
              );
          default:
              return null;
      }
  };

  
  const handleNavigate = ()=>{
    navigate("/gca-my-application");
  }


  return (
    <div>
            {isAllowed===false ? (
        <div className="container mt-5 pt-5 page-wrapper text-center">
          <div className="alert d-flex flex-column alert-warning d-inline-block px-4 py-3 shadow-sm">
            <p className="mb-1 fs-25 fw-semibold">
              You already have an active application.
            </p>
            <small className="fs-17 text-muted">
              You can apply or renew only within <strong>2 months</strong> before the expiry date.
            </small>
            <div className="mt-3 d-flex align-items-center justify-content-center">
                <button className="btn btn-info w-25" onClick={handleNavigate}>Go to Your application </button>
            </div>
          </div>
          
        </div>

        ) : (
    <div>
      <div className="cardhead page-wrapper">
        <div className="container-fluid content">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col">
                <h3 className="page-title">{language.license} -</h3>
              
              </div>
            </div>
          </div>
          {/* /Page Header */}
         
          <div className="row">
            <div className="col-md-12">
              <div className="card">
              
                <>  
             <div className="card-body">
             <div className="container mt-4">
            {/* Pipeline Navigation */}
            <div className="d-flex flex-wrap border-0 justify-content-center candidates mb-0 mb-4 pipeline-list">
                <ul className="d-flex  flex-wrap list-unstyled mb-0 justify-content-center">
                    {steps.map((step, index) => (
                        <>
                        {!(step.name === language.firm_info && entityType !== "Firm") && (
                        <li key={index} className="mx-2 my-2">
                          <Link
                          to="#"
                          className={`px-3 py-2 d-inline-block rounded 
                            ${index <= currentStep ? "bg-info text-white" : "bg-gray-100 text-dark"}`}
                          >
                          <span className="text-nowrap">{step.name}</span>
                          </Link>
                        </li>
                        )}
                        </>
                    ))}
                </ul>
            </div>

            {/* Form Sections */}
          
            <div className="p-4">
              {renderFormFields()}
           
          </div>
        </div>
             </div></>
             
            
              </div>
            </div>
          </div>
      
        </div>
      </div>
      <ToastContainer position="top-right" autoClose={3000} />
      </div>)}
    </div>
  );
};

export default GCALicenseRegistrationForm;

